import assets from './assets.js';
import categories from './categories.js';

const items = [
  {
    id: 0,
    name: 'Userflows for Marvel',
    url: 'https://userflows.marvelapp.com',
    isExternal: true,
    asset: assets.userflows,
    category: categories.experiments,
    description:
      'Turn your Marvel prototypes into interactive user journeys that give you a...',
  },
  {
    id: 1,
    name: '13 Pure CSS Mobile Devices.css',
    url: 'https://marvelapp.github.io/devices.css/',
    isExternal: true,
    asset: assets.devices,
    category: categories.openSource,
    description:
      "We've created several minimal iPhone, Android, Lumia and iPad devices in pure...",
  },
  {
    id: 2,
    name: 'Creating and Maintaining the Marvel Style Guide in Sketch',
    url:
      'https://blog.marvelapp.com/creating-maintaining-marvel-style-guide-sketch/',
    isExternal: true,
    asset: assets.styleguide,
    category: categories.blogArticle,
    description:
      'The essence of digital product design lies in identifying problems, solving those and... ',
  },
  {
    id: 3,
    name: 'Mobile Devices Sketch Paper',
    url: '/sketchpad',
    isExternal: true,
    asset: assets.sketchPaper,
    category: categories.resources,
    description:
      'Need something to draw on? Download our free printable templates and bring your ideas to life.',
  },
  {
    id: 4,
    name: 'Marvel for Keynote',
    url: 'https://keynote.marvelapp.com',
    isExternal: true,
    asset: assets.keynote,
    category: categories.openSource,
    description:
      'This simple Mac app gives you a quick way to upload Keynote files to Marvel in just a couple...',
  },
  {
    id: 5,
    name: "Marvel's Style Guide",
    url: 'https://marvelapp.com/styleguide',
    isExternal: true,
    asset: assets.styleguideSite,
    category: categories.openSource,
    description:
      'As Marvel continues to grow, both as a product and a company, one challenge we are faced...',
  },
  {
    id: 6,
    name: 'Dashboard',
    url: 'https://dashboard.marvelapp.com',
    isExternal: true,
    asset: assets.dashboard,
    category: categories.openSource,
    description:
      'It syncs with your Marvel account and displays what your team is working in real-time...',
  },
  {
    id: 7,
    name: 'BotBot',
    url: 'https://botbot.marvelapp.com',
    isExternal: true,
    asset: assets.botBot,
    category: categories.openSource,
    description:
      'This integration combines the power of Marvel with everyone’s favourite messaging...',
  },
];

export default items;



// WEBPACK FOOTER //
// ./src/configs/pages/labs/items.js